<template>
  <div>
    <div class="item">
      <span>進場動畫</span>
      <el-switch
        v-model="VoiceRoomIM.hasEntryAnimation"
        @change="changeEntryAnimation"
      >
      </el-switch>
    </div>
    <div class="item">
      <span>送禮動畫</span>
      <el-switch
        v-model="VoiceRoomIM.hasSendGiftAnimation"
        @change="changeSendGiftAnimation"
      >
      </el-switch>
    </div>
  </div>
</template>
<script>
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';

export default {
  name: 'AnimationSwitch',
  props: {},
  data() {
    return {
      VoiceRoomIM: VoiceRoomIM
    };
  },
  watch: {},
  computed: {},
  methods: {
    changeEntryAnimation($event) {
      $event
        ? localStorage.setItem('voiceRoomEntryAnimation', 'true')
        : localStorage.setItem('voiceRoomEntryAnimation', 'false');
    },
    changeSendGiftAnimation($event) {
      $event
        ? localStorage.setItem('voiceRoomSendGiftAnimation', 'true')
        : localStorage.setItem('voiceRoomSendGiftAnimation', 'false');
    }
  },
  created() {
    VoiceRoomIM.hasEntryAnimation =
      localStorage.getItem('voiceRoomEntryAnimation') === 'false'
        ? false
        : true;
    VoiceRoomIM.hasSendGiftAnimation =
      localStorage.getItem('voiceRoomSendGiftAnimation') === 'false'
        ? false
        : true;
  }
};
</script>
<style lang="scss" scoped>
.btn-switch {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  font-size: 14px;
  border-radius: 42px;
  padding: 0 28px 0 28px;
  border: none;
  margin-right: 10px;
  /deep/ span {
    display: flex;
    align-items: center;
    height: 44px;
  }
}
.item {
  display: flex;
  align-items: center;
  height: 40px;
  justify-content: space-between;
  > span {
    display: inline-block;
    margin-right: 5px;
  }
}
</style>
